import { oldBaseApi } from "../../api";

export type GetProjectContractsRequest = {
  projectId: string;
};
export type GetProjectContractsResponse = any;
export const getProjectContracts = async ({
  projectId,
}: GetProjectContractsRequest): Promise<GetProjectContractsResponse> => {
  const r = await oldBaseApi.get(
    `api/contracts/hierarchy/byprojectid/${projectId}`,
  );
  return r.data;
};
